import { render, staticRenderFns } from "./CaisseTable.vue?vue&type=template&id=030dc3ae"
import script from "./CaisseTable.vue?vue&type=script&lang=js"
export * from "./CaisseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports